<template>
  <div>
    <b-card bg-variant="none">
      <div v-if="storage_space_filtering.collection_ids">
        <storage-space-dropdown @selectedItems="setStorageSpace" :filtering="storage_space_filtering"></storage-space-dropdown>
      </div>
      <interest-dropdown @selectedItems="setInterestId" :filtering="interest_filtering"> </interest-dropdown>

      <find-or-create-brand
        v-model="brand" @product_obj="updateBrand" @clear_obj="clearBrand"
      ></find-or-create-brand>
      <div v-if="showProductModel">
        <find-or-create-product-model
          v-model="product_model" @product_obj="updateModel" @clear_obj="clearModel"
          :brand_ids="brand_ids"
          :interest_id="interest_id"
        ></find-or-create-product-model>
      </div>
      <div v-if="showProductListing">
        <find-or-create-product-listing
          v-model="product_listing" @product_obj="updateListing" @clear_obj="clearListing"
          :product_model_ids="product_model_ids"
        ></find-or-create-product-listing>
      </div>
      <div v-if="showProductItem">
        <find-or-create-product-item
          :collection_id="collection_id"
          :storage_space_id="storage_space_id"
          :interest_id="interest_id"
          v-model="product_item" @product_obj="updateItem" @clear_obj="clearItem"
          :product_listing_ids="product_listing_ids"
        ></find-or-create-product-item>
      </div>
      <div size="sm" class="mt-3">Using: <strong>{{ usageDescription }}</strong></div>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import FindOrCreateBrand from './FindOrCreateBrand'
import FindOrCreateProductModel from './FindOrCreateProductModel'
import FindOrCreateProductListing from './FindOrCreateProductListing'
import FindOrCreateProductItem from './FindOrCreateProductItem'
import StorageSpaceDropdown from './StorageSpaceDropdown.vue'
import InterestDropdown from './InterestDropdown.vue'

export default {
  components: {
    FindOrCreateBrand,
    FindOrCreateProductModel,
    FindOrCreateProductListing,
    FindOrCreateProductItem,
    StorageSpaceDropdown,
    InterestDropdown
  },
  props: {
    collection_id: {
      Type: String
    }
  },
  data () {
    return {
      brand: {attributes: {name: ''}},
      product_model: {attributes: {name: ''}},
      product_listing: {attributes: {edition: 0}},
      product_item: {attributes: {'serial-number': 0}},
      brand_ids: [],
      product_model_ids: [],
      product_listing_ids: [],
      product_item_ids: [],
      product_item_filtering: {
        collection_ids: this.collection_id,
        storage_space_ids: this.storage_space_id
      },
      storage_space_id: undefined,
      filtering: {
        collection_ids: this.collection_id
      },
      storage_space_filtering: {
        storage_accesses: ['access_enclosed', 'access_open'],
        collection_ids: this.collection_id
      },
      interest_id: undefined,
      interest_filtering: {
        ids: this.$store.getters['cached_products/interest_ids']
      }
    }
  },
  computed: {
    ...mapGetters({
      cached_brands: 'cached_products/brands',
    }),
    showProductModel() {
      return this.brand?.id
    },
    showProductListing() {
      return this.product_model?.id
    },
    showProductItem() {
       return this.product_listing?.id
    },
    usageDescription() {
      return [
        this.brand.attributes['name'],
        this.product_model.attributes['name'],
        this.product_listing.attributes['edition'],
        this.product_item.attributes['serial-number']
      ].filter(Boolean).join(":")
      // filter(Boolean) to remove any falsies, undefined, nulls, etc.
    },
  },
  methods: {
    updateBrand (val) {
      this.brand = val
      this.product_model = {attributes: {name: ''}}
      this.product_listing = {attributes: {edition: 0}}
      this.product_item = {attributes: {'serial-number': 0}}
    },
    clearBrand() {
      this.brand = {attributes: {name: ''}}
      this.clearModel()
    },
    updateModel(val) {
      this.brand = this.cached_brands.find( 
        el =>  
        el.attributes['id'] === val.attributes['brand-id']
      )
      this.product_model = val
      this.product_listing = {attributes: {edition: 0}}
      this.product_item = {attributes: {'serial-number': 0}}
    },
    clearModel() {
      this.product_model = {attributes: {name: ''}}
      this.clearListing()
    },
    updateListing(val) {
      this.product_listing = val
      this.product_item = {attributes: {'serial-number': 0}}
    },
    clearListing() {
      this.product_listing = {attributes: {edition: 0}}
      this.clearItem()
    },
    updateItem(val) {
      this.product_item = val
    },
    clearItem() {
      this.product_item = {attributes: {'serial-number': 0}}
    },
    setStorageSpace(items) {
      this.storage_space_id = items[0].id
      this.product_item_filtering.storage_space_ids = items[0].id
    },
    setInterestId(items) {
      this.interest_id = items[0].id
    }
  },
  watch: {
    brand(newVal) {
      this.brand_ids = [newVal.id]
    },
    product_model(newVal) {
      this.product_model_ids = [newVal.id]    
    },
    product_listing(newVal) {
      this.product_listing_ids = [newVal.id]
    },
    product_item(newVal) {
      this.product_item_ids = [newVal.id]
      this.$emit('usingProduct', newVal)
    },
    collection_id(newVal) {
      this.filtering.collection_ids = newVal
      this.storage_space_filtering.collection_ids = newVal
    }
  }
}
</script>
